import { render } from "./slider.vue?vue&type=template&id=0021d39e"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"

import "./slider.vue?vue&type=style&index=0&id=0021d39e&lang=less"

import exportComponent from "E:\\05projects\\fullstack\\who-clicked-clock\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__